module.exports = __webpack_public_path__ + "img/other.158ca4e8.svg";